import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { loadRuntimeEnv } from "./shared/config/runtimeEnv";
import { initSentry } from "./shared/sentry";

async function bootstrap() {
  await Promise.all([loadRuntimeEnv(), initSentry()]);
  const { default: App } = await import("./App");

  createRoot(document.getElementById("root")!).render(
    <BrowserRouter>
      <App />
    </BrowserRouter>,
  );
}

void bootstrap();
